module.exports = __webpack_public_path__ + "static/media/baseline-menu-24px.c275e518.svg";